module.exports = __webpack_public_path__ + "img/ropa-cama.f5bb6792.svg";